// extracted by mini-css-extract-plugin
export default {"descriptionText":"columns-selector_descriptionText__PIvIa","transferComponent":"columns-selector_transferComponent__UpVnW"};